class Zoom {
    static init() {
        var pdp = document.getElementsByClassName('product-page');
        if( pdp.length !== 0) {
            console.log(pdp);

            document.getElementById('toggleform').onclick = function() {
                document.getElementById('interesse-container').classList.add("_active");
            }

            document.getElementById('formoff').onclick = function() {
                document.getElementById('interesse-container').classList.remove("_active");
            }
        }
    }
}

export { Zoom };